import api from "@/api/axiosConfig.js";
import { handleSuccessResponse, handleErrorResponse } from '@/api/apiUtils.js';

const MODULE_NAME = 'PasswordAPI';

export const passwordAPI = {
  get: async (projectUUID, showNotification = true) => {
    try {
      const response = await api.get(`/${projectUUID}/passwords`);
      return handleSuccessResponse(response, MODULE_NAME, 'Получение паролей проекта', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получении паролей проекта');
    }
  },

  post: async (projectUUID, param, showNotification = true) => {
    try {
      const response = await api.post(`/${projectUUID}/passwords`, param);
      return handleSuccessResponse(response, MODULE_NAME, 'Создание паролей проекта', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'cоздание паролей проекта');
    }
  },

  delete: async (projectUUID, param, showNotification = true) => {
    try {
      const response = await api.delete(`/${projectUUID}/passwords`, {params: param} );
      return handleSuccessResponse(response, MODULE_NAME, 'Удаление паролей проекта', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'удаление паролей проекта');
    }
  },
};